import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./Asociar.css";

const resumenMeta = (doc) => {
  const meta = (doc && doc.METADATX) || {};
  return Object.entries(meta)
    .filter(([, v]) => v !== "" && v != null)
    .slice(0, 2)
    .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
    .join("  ·  ");
};

const aplanar = (v) => {
  if (v == null) return [];
  if (Array.isArray(v)) return v.flatMap(aplanar);
  if (typeof v === "object") return Object.values(v).flatMap(aplanar);
  return [String(v)];
};

const textoBusqueda = (doc) =>
  [doc?.TIPODESX, ...aplanar(doc?.METADATX), ...aplanar(doc?.JSONMETX), doc?.IDARCHXX]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

const Asociar = ({ show, onClose, mode, fixedDoc, candidates = [], onConfirm, loading }) => {
  const [selected, setSelected] = useState([]);
  const [filtro, setFiltro] = useState("");
  const esModoHijo = mode === "hijo";

  useEffect(() => {
    setSelected([]);
    setFiltro("");
  }, [show, mode, fixedDoc]);

  const q = filtro.trim().toLowerCase();
  const visibles = q ? candidates.filter((d) => textoBusqueda(d).includes(q)) : candidates;

  const titulo = esModoHijo ? "Asociar documento hijo" : "Asociar a documento padre";
  const sinDisp = esModoHijo
    ? "Sin hijos disponibles para asociar."
    : "Sin padres disponibles para asociar.";
  const labelFijo = esModoHijo ? "Documento padre" : "Documento hijo";
  const labelLista = esModoHijo
    ? "Documentos disponibles para asociar"
    : "Documentos padre disponibles";

  const toggle = (id) => {
    const s = String(id);
    setSelected((prev) => (prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s]));
  };

  const confirmar = () => {
    if (selected.length > 0) onConfirm(selected);
  };

  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header style={{ backgroundColor: "#000000", color: "white" }}>
        {titulo}
        <Button className="btn-close btn-close-white" aria-label="Close" onClick={onClose} />
      </Modal.Header>
      <Modal.Body>
        <div className="asoc-fixed">
          <span className="asoc-fixed__lbl">{labelFijo}</span>
          <div className="asoc-fixed__tipo">{fixedDoc?.TIPODESX}</div>
          <div className="asoc-fixed__meta">{resumenMeta(fixedDoc)}</div>
        </div>

        {candidates.length === 0 ? (
          <div className="asoc-empty">{sinDisp}</div>
        ) : (
          <>
            <div className="asoc-list__hdr">
              {labelLista}
              <span className="asoc-list__count">
                {selected.length} seleccionado{selected.length === 1 ? "" : "s"}
              </span>
            </div>
            <input
              type="text"
              className="asoc-search"
              placeholder="Buscar por tipo o cualquier metadato…"
              value={filtro}
              onChange={(e) => setFiltro(e.target.value)}
            />
            {visibles.length === 0 ? (
              <div className="asoc-empty">Sin resultados para “{filtro}”.</div>
            ) : (
              <div className="asoc-list">
                {visibles.map((doc) => {
                  const id = String(doc.IDARCHXX);
                  const on = selected.includes(id);
                  return (
                    <label key={id} className={`asoc-item ${on ? "asoc-item--on" : ""}`}>
                      <Form.Check type="checkbox" checked={on} onChange={() => toggle(id)} />
                      <div className="asoc-item__body">
                        <div className="asoc-item__tipo">{doc.TIPODESX}</div>
                        <div className="asoc-item__meta">{resumenMeta(doc)}</div>
                      </div>
                    </label>
                  );
                })}
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-yellow m-2"
          disabled={loading || selected.length === 0}
          onClick={confirmar}
        >
          {loading ? (
            <i className="spinner-border spinner-border-sm" role="status"></i>
          ) : (
            `Asociar${selected.length ? ` (${selected.length})` : ""}`
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Asociar;
